import { Component } from '@angular/core';
import { ContentBlock, ContentBlockType } from '@tytapp/content';
import { ContentBlockEditorComponent } from '@tytapp/content/content-block-editor-component';
import { ContentBlockViewComponent } from '@tytapp/content/content-block-view-component';

export interface ContentViewBlock extends ContentBlock {
    blocks: ContentBlock[];
    mode: 'standard' | 'split' | 'sidebar-left';
}

@Component({
    template: `<tyt-content-view [mode]="block.mode" [blocks]="block.blocks"></tyt-content-view>`
})
export class ViewComponent extends ContentBlockViewComponent<ContentViewBlock> {
}

@Component({
    template: `
        <mat-button-toggle-group
            #group="matButtonToggleGroup"
            [value]="block.mode"
            (change)="handleChange(group.value)">
            <mat-button-toggle value="standard">Standard</mat-button-toggle>
            <mat-button-toggle value="split">Split</mat-button-toggle>
            <mat-button-toggle value="sidebar-left">Sidebar Left</mat-button-toggle>
        </mat-button-toggle-group>
        <tyt-content-editor [blocks]="block.blocks"></tyt-content-editor>
    `,
    styles: [`
        tyt-content-editor {
            display: block;
            margin: 1em;
        }

        .standard {
            display: block;
        }

        .split {
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            /* each child must have equal width */
            > * {
                flex: 1;
            }
        }

        .sidebar-left {
            display: flex;
            flex-direction: row;

            /*
               The first child should be the sidebar and will take 25% of the width,
               The second child (main content) will take the remaining 75%
            */
            > *:first-child {
                flex: 1;
            }
            > *:last-child {
                flex: 3;
            }
        }

        mat-button-toggle-group {
            margin: 1em;
        }
    `]
})
export class EditorComponent extends ContentBlockEditorComponent<ContentViewBlock> {
    handleChange(value: 'standard' | 'split' | 'sidebar-left') {
        this.block.mode = value;
    }
}

export const CONTENT_VIEW_BLOCK_TYPE: ContentBlockType<ContentViewBlock> = {
    id: 'content-view',
    label: 'Content View',
    icon: 'dashboard',
    template: {
        blocks: []
    },
    editorComponent: EditorComponent,
    viewComponent: ViewComponent
};
